<div
  class="munily-input-preview"
  [ngClass]="containerClasses"
  [attr.role]="clickable ? 'button' : null"
  [attr.tabindex]="clickable ? 0 : null"
  (click)="onClick()"
>
  <mat-icon
    *ngIf="showLeadingIcon"
    class="munily-input-preview__leading-icon material-symbols-rounded"
    aria-hidden="true"
  >{{ leadingIcon }}</mat-icon>

  <div class="munily-input-preview__labels">
    <span *ngIf="showLabel && label" class="munily-input-preview__label">{{ label }}</span>
    <ng-container *ngIf="hasValue; else emptyValue">
      <div
        class="munily-input-preview__value munily-description-preview__rich"
        [innerHTML]="value | safeHtml"
      ></div>
    </ng-container>
    <ng-template #emptyValue>
      <p class="munily-input-preview__value munily-description-preview__empty-line">{{ emptyText }}</p>
    </ng-template>
  </div>

  <span
    *ngIf="showEditIcon"
    class="munily-description-preview__edit-anchor"
    [class.munily-description-preview__edit-anchor--align-start]="editIconVerticalAlign === 'start'"
  >
    <common-icon-button
      variant="plain"
      icon="edit"
      iconSet="material-icons-outlined"
      ariaLabel="Editar"
      class="munily-input-preview__edit-btn"
      (output)="onEdit()"
    ></common-icon-button>
  </span>
</div>
